import { html, LitElement, css, PropertyValues, nothing } from 'lit';
import {property, customElement} from 'lit/decorators.js';
import { voyageRadioButtonsStyle } from '../../voyage-style/src/voyage-style';
import '../../voyage-weather-control/src/voyage-weather-control';
import '../../voyage-ship-weather-expectation-player/src/voyage-ship-weather-expectation-player';
import '../../voyage-vessel-spot-weather-control/src/voyage-vessel-spot-weather-control'
import '../../voy-panel/src/voy-panel'
import "@maersk-global/mds-components-core";

import { MapCoordinates } from '../../voyage-vessel-spot-weather-control/src/voyage-vessel-spot-weather-control';
import { UiStateModel, UiStateModelParam } from '../../../src/models/ui-state-model';
import { SvgIcons } from '../../voyage-svg-icons/src/voyage-svg-icons';
import { saveFile } from '../../../src/utils/utils';
import { WeatherModel } from '../../../src/models/weather-model';

export enum WeatherControlMode {
    ShowCompass = "showCompass",
    ShowSpot = "showSpot",
    ShowLayers = "showLayers",
    ShowReportProblem = "showReportProblem"
}

const isVesselOnCloud = (<any>window)["appenv"].vesselOnCloud;


@customElement('voyage-vessel-weather-control')
export class VoyageVesselWeatherControl extends LitElement
{
    @property({type: String}) mode: string = "";
    @property({type: Number}) playerTime: number = Date.now();
    @property({type: Object}) mapCoordinates: MapCoordinates|null = null;
    @property({ attribute: false }) showComponent: WeatherControlMode = WeatherControlMode.ShowCompass;
    
    @property({type: Boolean}) private _loadingWeatherInfoFailed: boolean = false;
    @property({type: Boolean}) private _weatherReportGenerated: boolean = false;

    static get styles() {
        return [
            voyageRadioButtonsStyle,
            css`
                :host {
                    display: none;
                }

                :host([shown]) {
                    display: flex;
                    flex-direction: column;
                    position: fixed;
                    top: 95px;
                    right: 5px;
                    bottom: 200px;
                    z-index: 3;
                }

                #container {
                    width: 423px;
                    margin-left: auto;
                    top: 45px;
                    right: 0px;
                    position: absolute;
                }

                voy-panel {
                    display: none;
                    position: relative;
                    height: 240px;
                }

                voy-panel[shown] {
                    display: block;
                }

                #container>* {
                    margin-left: auto;
                }

                .radioContainer {
                    box-sizing: border-box;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    padding-right: 15px;
                    padding-left: 15px;
                    width: 528px;
                    height: 41px;
                    min-height: 41px;
                    background-color: var(--neutrals-grey-10, white);
                    margin-bottom: 10px;
                    box-shadow: 1px 1px 5px var(--secondary-voyage-box-shadow);
                    border: 1px solid var(--neutrals-grey-06, black);
                }

                .radioAndLabel {
                    pointer-events: auto;
                    align-items: center;
                    display: flex;
                }
                .radioAndLabel > * {
                    cursor: pointer;
                }

                label {
                    margin-left: 5px;
                    font-family: MaerskText;
                    font-size: 14px;
                    color: var(--neutrals-grey-03, black);
                }

                .layersContainer {
                    display: none;
                }

                .layersContainer[shown] {
                    display: flex;
                    flex-direction: column;
                    background: var(--neutrals-grey-10, white);
                    padding: 5px;
                    box-shadow: 1px 1px 5px var(--secondary-voyage-box-shadow);
                    border: 1px solid var(--neutrals-grey-06, black);
                }

                .compassContainer {
                    display: none;
                }

                .compassContainer[shown] {
                    display: flex;
                    flex-direction: column;
                }

                .report-weather-container {
                    font-family: MaerskText;
                    color: var(--functional-grey-900, black);
                }

                .weather-report-confirmation {
                    display: flex;
                    box-sizing: border-box;
                    align-items: center;
                    width: 100%;
                    height: 44px;
                    background-color: var(--feedback-sucess-light, lightgreen);
                    border-radius: 4px;
                    padding: 12px;
                    margin-bottom: 16px;
                    pointer-events: none;
                }
                
                .weather-report-confirmation[failed] {
                    background-color: var(--feedback-danger-light, red);
                }

                .weather-report-confirmation svg {
                    width: 16px;
                    margin-right: 14px;
                }

                .weather-report-confirmation-text {
                    padding-bottom: 4px;
                }

                .send-report {
                    cursor: pointer;
                }
                
                .tab-container {
                    display: flex;
                    flex-direction: row;
                    background-color: white;
                    justify-content: space-between;
                    box-shadow: 1px 1px 5px var(--secondary-voyage-box-shadow);
                    border-radius: 4px;
                }

                mc-button {
                    position: absolute;
                    bottom: 16px;
                    right: 16px;
                }
        `];
    }

    render() {
        return html`
            <div class='tab-container'>
                <mc-tab fit="small" data-test="show-compass" label="Route weather" @click=${() => this.changeTab(WeatherControlMode.ShowCompass)} .active=${this.showComponent === WeatherControlMode.ShowCompass} ></mc-tab>
                <mc-tab fit="small" label="Spot-weather" @click=${() => this.changeTab(WeatherControlMode.ShowSpot)} .active=${this.showComponent === WeatherControlMode.ShowSpot}></mc-tab>
                <mc-tab fit="small" data-test="show-layers" label="Weather layers" @click=${() => this.changeTab(WeatherControlMode.ShowLayers)} .active=${this.showComponent === WeatherControlMode.ShowLayers}></mc-tab>
                ${!isVesselOnCloud ? html`<mc-tab fit="small" data-test="report-problem" label="Report problem" @click=${() => this.changeTab(WeatherControlMode.ShowReportProblem)} .active=${this.showComponent === WeatherControlMode.ShowReportProblem}></mc-tab>`: nothing}
            </div>

            <div id="container">
                <div class="layersContainer" ?shown=${this.showComponent === WeatherControlMode.ShowLayers}>
                    <voyage-weather-control></voyage-weather-control>
                </div>
                <div class="compassContainer" ?shown=${this.showComponent === WeatherControlMode.ShowCompass}>
                    <voyage-ship-wx-player .mode=${this.mode} .currentTime=${this.playerTime}></voyage-ship-wx-player>
                </div>
                <voyage-vessel-spot-weather-control ?shown=${this.showComponent === WeatherControlMode.ShowSpot} .playerTime=${this.playerTime} .mapCoordinates=${this.mapCoordinates}></voyage-vessel-spot-weather-control>
                <voy-panel ?shown=${this.showComponent === WeatherControlMode.ShowReportProblem} panelTitle="Report Problem">
                    ${this._reportProblemComponent()}
                </voy-panel>
            </div>
        `;
    }

    updated(changedProperties: PropertyValues) {
        changedProperties.forEach((oldValue, propName) => {
            if (propName === "showComponent") {
                UiStateModel!.setValue(UiStateModelParam.SelectedWeatherControlComponent, this.showComponent);
                this._weatherReportGenerated = false;
            }

            if (propName === "shown") {
                this._weatherReportGenerated = false;
            }
        });
    }

    changeTab(clickedTab: WeatherControlMode) {
        this.showComponent = clickedTab;
    }

    private _reportProblemComponent() {
        return html`
            <div class="report-weather-container">
                ${this._confirmLoadedWeather()}
                <span class="send-report">Send report file to vitservicedesk@maersk.com</span>
                <mc-button
                    @click=${this._downloadWeatherProblemJson}
                >
                    Generate Report
                </mc-button>
            </div>
        `
    }

    private async _downloadWeatherProblemJson() {
        const latestForecast = WeatherModel!.latestForecastInfo;
        
        if (latestForecast) {
            const json = JSON.stringify(latestForecast);
            saveFile("weather-report.json", 'application/json', json);
            this._weatherReportGenerated = true;
            this._loadingWeatherInfoFailed = false;
        } else {
            this._loadingWeatherInfoFailed = true;
        }
    }

    private _confirmLoadedWeather() {
        if (!this._loadingWeatherInfoFailed && !this._weatherReportGenerated) return;

        const text = this._weatherReportGenerated ? "Weather report has been generated" : "A problem has occured, please try again.";
        const icon = this._weatherReportGenerated ? SvgIcons.lightCheckCircle : SvgIcons.lightExclamationCircle;
        
        return html`
            <div class="weather-report-confirmation" ?failed=${this._loadingWeatherInfoFailed}>
                <span>${icon}</span>
                <span class="weather-report-confirmation-text">${text}</span>
            </div>
        `
        
    }
}
